import { configureStore } from "@reduxjs/toolkit";
import { 
	loginAndSignUp,
	footerdetailapi,
	ourTeamapi,
	jobgetapi,
	faqsApi,
} from "./action"

const store = configureStore({
	reducer: {
		loginAndSignUp,
		footerdetailapi,
		ourTeamapi,
		jobgetapi,
		faqsApi,
	},
})
export default store